interface PlaceholderProps {
  className?: string;
}
export function Placeholder(props: PlaceholderProps) {
  const { className } = props;

  return <div className={`rounded-xl bg-gray-200 p-3 animate-pulse ${className || ''}`}></div>;
}
